"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaWallet = void 0;
const react_1 = __importStar(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const react_shadow_dom_retarget_events_1 = __importDefault(require("react-shadow-dom-retarget-events"));
const wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
const wallet_adapter_react_1 = require("@solana/wallet-adapter-react");
const wallet_adapter_react_ui_1 = require("@solana/wallet-adapter-react-ui");
const wallet_adapter_wallets_1 = require("@solana/wallet-adapter-wallets");
// Need to import the styles for the modal (not in shadowroot)
require("@solana/wallet-adapter-react-ui/styles.css");
const SolanaReactWalletProvider = ({ children, }) => {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'. (TODO: set this in config)
    const network = wallet_adapter_base_1.WalletAdapterNetwork.Devnet;
    // const endpoint = useMemo(() => clusterApiUrl(network), [network]);
    const endpoint = "http://127.0.0.1:8899"; // TODO: make configurable
    const wallets = (0, react_1.useMemo)(() => [new wallet_adapter_wallets_1.PhantomWalletAdapter()], [network]);
    return react_1.default.createElement(wallet_adapter_react_1.ConnectionProvider, {
        endpoint: endpoint,
        children: react_1.default.createElement(wallet_adapter_react_1.WalletProvider, {
            wallets: wallets,
            autoConnect: true,
            children: react_1.default.createElement(wallet_adapter_react_ui_1.WalletModalProvider, {
                children: children,
            }),
        }),
    });
};
const SolanaWalletButton = ({ children, onConnectWallet, onDisconnectWallet }) => {
    const { wallet, publicKey, connected } = (0, wallet_adapter_react_1.useWallet)();
    const anchorWallet = (0, wallet_adapter_react_1.useAnchorWallet)();
    const { connection } = (0, wallet_adapter_react_1.useConnection)();
    (0, react_1.useEffect)(() => {
        if (anchorWallet && publicKey && connection && connected && wallet) {
            onConnectWallet({ wallet, anchorWallet });
        }
        else if (!connected) {
            onDisconnectWallet();
        }
    }, [wallet, publicKey, connection, anchorWallet, connected]);
    return connected
        ? react_1.default.createElement(wallet_adapter_react_ui_1.WalletDisconnectButton)
        : react_1.default.createElement(wallet_adapter_react_ui_1.WalletMultiButton);
};
let SolanaWallet = (() => {
    var _SolanaWallet_isConnected_accessor_storage;
    let _classDecorators = [(0, decorators_js_1.customElement)("solana-wallet")];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = lit_1.LitElement;
    let _instanceExtraInitializers = [];
    let _isConnected_decorators;
    let _isConnected_initializers = [];
    var SolanaWallet = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.mountPoint = (__runInitializers(this, _instanceExtraInitializers), void 0);
            _SolanaWallet_isConnected_accessor_storage.set(this, __runInitializers(this, _isConnected_initializers, false));
        }
        get isConnected() { return __classPrivateFieldGet(this, _SolanaWallet_isConnected_accessor_storage, "f"); }
        set isConnected(value) { __classPrivateFieldSet(this, _SolanaWallet_isConnected_accessor_storage, value, "f"); }
        onConnectWallet(walletDetail) {
            this.isConnected = true;
            this.dispatchEvent(new CustomEvent("on-connect-wallet", {
                bubbles: true,
                composed: true,
                detail: walletDetail,
            }));
        }
        onDisconnectWallet() {
            this.isConnected = false;
            this.dispatchEvent(new CustomEvent("on-disconnect-wallet", {
                bubbles: true,
                composed: true,
                detail: {},
            }));
        }
        connectedCallback() {
            super.connectedCallback();
            this.mountPoint = document.createElement("span");
            if (this.shadowRoot) {
                this.shadowRoot.appendChild(this.mountPoint);
                (0, react_shadow_dom_retarget_events_1.default)(this.shadowRoot);
            }
            client_1.default.createRoot(this.mountPoint).render(react_1.default.createElement(SolanaReactWalletProvider, {
                children: react_1.default.createElement(SolanaWalletButton, {
                    onConnectWallet: this.onConnectWallet.bind(this),
                    onDisconnectWallet: this.onDisconnectWallet.bind(this),
                    children: null,
                }),
            }));
        }
    };
    _SolanaWallet_isConnected_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SolanaWallet");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isConnected_decorators = [(0, decorators_js_1.property)({ attribute: false })];
        __esDecorate(_classThis, null, _isConnected_decorators, { kind: "accessor", name: "isConnected", static: false, private: false, access: { has: obj => "isConnected" in obj, get: obj => obj.isConnected, set: (obj, value) => { obj.isConnected = value; } }, metadata: _metadata }, _isConnected_initializers, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SolanaWallet = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    // copy from @solana/wallet-adapter-react-ui/styles.css, https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap
    _classThis.styles = (0, lit_1.css) `
    /* latin-ext */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6z9mXgjU0.woff2)
        format("woff2");
      unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F,
        U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
        U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K6z9mXg.woff2)
        format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
        U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC,
        U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    /* latin-ext */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 500;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6z9mXgjU0.woff2)
        format("woff2");
      unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F,
        U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
        U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 500;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K6z9mXg.woff2)
        format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
        U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC,
        U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    /* latin-ext */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 700;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6z9mXgjU0.woff2)
        format("woff2");
      unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F,
        U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,
        U+A720-A7FF;
    }
    /* latin */
    @font-face {
      font-family: "DM Sans";
      font-style: normal;
      font-weight: 700;
      font-display: swap;
      src: url(https://fonts.gstatic.com/s/dmsans/v14/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K6z9mXg.woff2)
        format("woff2");
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
        U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC,
        U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }

    .wallet-adapter-button {
      background-color: transparent;
      border: none;
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-family: "DM Sans", "Roboto", "Helvetica Neue", Helvetica, Arial,
        sans-serif;
      font-size: 16px;
      font-weight: 600;
      height: 48px;
      line-height: 48px;
      padding: 0 24px;
      border-radius: 4px;
    }

    .wallet-adapter-button-trigger {
      background-color: #512da8;
    }

    .wallet-adapter-button:not([disabled]):focus-visible {
      outline-color: white;
    }

    .wallet-adapter-button:not([disabled]):hover {
      background-color: #1a1f2e;
    }

    .wallet-adapter-button[disabled] {
      background: #404144;
      color: #999;
      cursor: not-allowed;
    }

    .wallet-adapter-button-end-icon,
    .wallet-adapter-button-start-icon,
    .wallet-adapter-button-end-icon img,
    .wallet-adapter-button-start-icon img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
    }

    .wallet-adapter-button-end-icon {
      margin-left: 12px;
    }

    .wallet-adapter-button-start-icon {
      margin-right: 12px;
    }

    .wallet-adapter-collapse {
      width: 100%;
    }

    .wallet-adapter-dropdown {
      position: relative;
      display: inline-block;
    }

    .wallet-adapter-dropdown-list {
      position: absolute;
      z-index: 99;
      display: grid;
      grid-template-rows: 1fr;
      grid-row-gap: 10px;
      padding: 10px;
      top: 100%;
      right: 0;
      margin: 0;
      list-style: none;
      background: #2c2d30;
      border-radius: 10px;
      box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.6);
      opacity: 0;
      visibility: hidden;
      transition: opacity 200ms ease, transform 200ms ease, visibility 200ms;
      font-family: "DM Sans", "Roboto", "Helvetica Neue", Helvetica, Arial,
        sans-serif;
    }

    .wallet-adapter-dropdown-list-active {
      opacity: 1;
      visibility: visible;
      transform: translateY(10px);
    }

    .wallet-adapter-dropdown-list-item {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: none;
      outline: none;
      cursor: pointer;
      white-space: nowrap;
      box-sizing: border-box;
      padding: 0 20px;
      width: 100%;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 600;
      height: 37px;
      color: #fff;
    }

    .wallet-adapter-dropdown-list-item:not([disabled]):hover {
      background-color: #1a1f2e;
    }

    .wallet-adapter-modal-collapse-button svg {
      align-self: center;
      fill: #999;
    }

    .wallet-adapter-modal-collapse-button.wallet-adapter-modal-collapse-button-active
      svg {
      transform: rotate(180deg);
      transition: transform ease-in 150ms;
    }

    .wallet-adapter-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity linear 150ms;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1040;
      overflow-y: auto;
    }

    .wallet-adapter-modal.wallet-adapter-modal-fade-in {
      opacity: 1;
    }

    .wallet-adapter-modal-button-close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 18px;
      right: 18px;
      padding: 12px;
      cursor: pointer;
      background: #1a1f2e;
      border: none;
      border-radius: 50%;
    }

    .wallet-adapter-modal-button-close:focus-visible {
      outline-color: white;
    }

    .wallet-adapter-modal-button-close svg {
      fill: #777;
      transition: fill 200ms ease 0s;
    }

    .wallet-adapter-modal-button-close:hover svg {
      fill: #fff;
    }

    .wallet-adapter-modal-overlay {
      background: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .wallet-adapter-modal-container {
      display: flex;
      margin: 3rem;
      min-height: calc(100vh - 6rem); /* 100vh - 2 * margin */
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 480px) {
      .wallet-adapter-modal-container {
        margin: 1rem;
        min-height: calc(100vh - 2rem); /* 100vh - 2 * margin */
      }
    }

    .wallet-adapter-modal-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      z-index: 1050;
      max-width: 400px;
      border-radius: 10px;
      background: #10141f;
      box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.6);
      font-family: "DM Sans", "Roboto", "Helvetica Neue", Helvetica, Arial,
        sans-serif;
      flex: 1;
    }

    .wallet-adapter-modal-wrapper .wallet-adapter-button {
      width: 100%;
    }

    .wallet-adapter-modal-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      margin: 0;
      padding: 64px 48px 48px 48px;
      text-align: center;
      color: #fff;
    }

    @media (max-width: 374px) {
      .wallet-adapter-modal-title {
        font-size: 18px;
      }
    }

    .wallet-adapter-modal-list {
      margin: 0 0 12px 0;
      padding: 0;
      width: 100%;
      list-style: none;
    }

    .wallet-adapter-modal-list .wallet-adapter-button {
      font-weight: 400;
      border-radius: 0;
      font-size: 18px;
    }

    .wallet-adapter-modal-list .wallet-adapter-button-end-icon,
    .wallet-adapter-modal-list .wallet-adapter-button-start-icon,
    .wallet-adapter-modal-list .wallet-adapter-button-end-icon img,
    .wallet-adapter-modal-list .wallet-adapter-button-start-icon img {
      width: 28px;
      height: 28px;
    }

    .wallet-adapter-modal-list .wallet-adapter-button span {
      margin-left: auto;
      font-size: 14px;
      opacity: 0.6;
    }

    .wallet-adapter-modal-list-more {
      cursor: pointer;
      border: none;
      padding: 12px 24px 24px 12px;
      align-self: flex-end;
      display: flex;
      align-items: center;
      background-color: transparent;
      color: #fff;
    }

    .wallet-adapter-modal-list-more svg {
      transition: all 0.1s ease;
      fill: rgba(255, 255, 255, 1);
      margin-left: 0.5rem;
    }

    .wallet-adapter-modal-list-more-icon-rotate {
      transform: rotate(180deg);
    }

    .wallet-adapter-modal-middle {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 24px 24px 24px;
      box-sizing: border-box;
    }

    .wallet-adapter-modal-middle-button {
      display: block;
      cursor: pointer;
      margin-top: 48px;
      width: 100%;
      background-color: #512da8;
      padding: 12px;
      font-size: 18px;
      border: none;
      border-radius: 8px;
      color: #fff;
    }
  `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SolanaWallet = _classThis;
})();
exports.SolanaWallet = SolanaWallet;
